import styled from 'styled-components';

import ToolIcon from 'components/Icons/ToolIcon';

export default styled.input`
  background-color: inherit;
  border: initial;
  color: inherit;
  display: block;
  font-family: inherit;
  font-size: inherit;
  width: 100%;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  left: -1000em;
  position: absolute;

  &:focus {
    outline: none;
  }
`;
